import { Franchise, Store } from '../../../../app/services/api/generated';
import type { DemandModifier } from '../../../../app/services/api/orderManagementClient';

export type { DemandModifier };

export const DemandModifierTargetType = {
  AllItems: 'allItems',
  SpecificCategories: 'specificCategories',
  SpecificSKUs: 'specificSKUs',
} as const;

export const DemandModifierLocationType = {
  AllFranchises: 'allFranchises',
  SpecificFranchises: 'specificFranchises',
  SpecificStores: 'specificStores',
} as const;

export const DemandModifierType = {
  PercentageUplift: 'percentageUplift',
  QuantityOffset: 'quantityOffset',
} as const;

export type DemandModifierTargetTypeValue = typeof DemandModifierTargetType[keyof typeof DemandModifierTargetType];
export type DemandModifierLocationTypeValue = typeof DemandModifierLocationType[keyof typeof DemandModifierLocationType];
export type DemandModifierTypeValue = typeof DemandModifierType[keyof typeof DemandModifierType];

export interface DemandModifierFormData {
  name: string;
  startDate: string;
  endDate: string;
  targetType: DemandModifierTargetTypeValue;
  selectedCategories: { id: number; name: string }[];
  selectedSKUs: string[];
  locationType: DemandModifierLocationTypeValue;
  selectedFranchises: Franchise[];
  selectedStores: Store[];
  modifierType: DemandModifierTypeValue;
  upliftPercentage: number;
  quantityOffset: number;
}
